<template>
  <div class="screen-container">
    <div class="screen-header">
      <!-- SortingStation -->
      <div class="left">
        Sorting Station : <div class="yelloText"> {{ SortingStation }} </div>
      </div>
      <!-- waveStatus -->
      <div class="center" v-if="waveStatus == 'completed'">Complete</div>
      <!-- waveId -->
      <div class="right">
        Wave : <div class="redText"> {{ waveId }} </div>
      </div>
    </div>
    <div class="screen-body">
      <div class="body-box">
        <div class="body-left">
          <div class="body-left-select">
            <div :class="currentIndex == index ? 'numTips num':'num'" v-for="(item,index) in leftListData" :key="index" @mouseenter="goToSlide(index)" @mouseleave="isPlay = true;startAutoPlay()">
              {{ index + 1 }}
            </div>
          </div>
          <!-- leftListData -->
          <div class="body-left-title">
            <div style="width:55%;padding-left: 10%;">Order ID</div>
            <div style="width:25%">Basket ID</div>
            <div style="width:20%">Progress</div>
          </div>
          <div class="body-left-list">
            <div class="left-box">
              <div v-for="(item,index) in leftDataShowList" :key="index" 
              :class="
                (item.isGreen&&index<19) ? 'product greenTips' : 
                (item.isRed&&index<19) ? 'product redTips' : 
                (!item.isGreen&&!item.isRed&&index<19) ? 'product' : 
                (item.isGreen&&index==19) ? 'product_bot greenTips' : 
                (item.isRed&&index==19) ? 'product_bot redTips' : 
                'product_bot'"
              >
                <div>{{item.outerOrderNo}}</div>
                <div>{{item.basketNo}}</div>
                <div>{{item.sortQty+'/'+item.totalItemQty}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="body-center">
          <!-- centerNumber -->
          <div ref="pdfTemple" class="centerNum">{{ centerNumber }}</div>
          <!-- tips -->
          <div class="tips" v-if="tipsNumber">+{{ tipsNumber }}</div>
          <!-- SKUCode / LRI-SDWAN-LIGHT -->
          <div class="centerCode">
            <div style="font-weight: bold">{{ SKUCode }}</div>
            <div v-if="SKUCode">{{ pickQty }} / {{ totalItemQty }}</div>
          </div>
        </div>
        <!-- pickHistoryList -->
        <div class="body-right">
          <div class="body-right-title">
            <div style="width:20%;padding-left: 10%;">No. </div>
            <div style="width:50%;text-align: center;">SKU</div>
            <div style="width:30%">Basket ID</div>
          </div>
          <div class="right-box">
            <div v-for="(item,index) in pickHistoryList" :key="index" :class="index<19?'product':'product_bot'">
              <div>{{item.rowNum}}</div>
              <div>{{item.skuCode}}</div>
              <div>{{item.basketId}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { waveApi } from '@/api';
import { VUE_APP_WAVE_API } from '@/utils/index';

export default {
  name: 'WavePage',
  data() {
    return {
      // 分拣台
      SortingStation: this.$route.query.SortingStation || null,
      // 波次状态   ==>>>   processing：处理,   completed：完成,   pending：待定
      waveStatus:null,
      // 波次号
      waveId : null,
      // 大屏数字/篮子号
      centerNumber : null,
      // 重复标红提示
      tipsNumber : 0,
      // 大屏sku编码
      SKUCode : null,
      // 大屏已扫描商品数量
      pickQty : null,
      // 大屏总商品数量
      totalItemQty : null,
      // 左侧总数据
      leftListData:[],
      // 左侧轮播数据
      leftDataShowList:[],
      // 右侧列表数据
      pickHistoryList:[],
      // 定时器
      timer: null,
      // 定时器
      timeout: null,
      // 左侧轮播页脚
      currentIndex: 0,
      isPlay: true,
      sse: null,
      isPrinting: false,
      printQueue: [],
      printJobSeq: 0
    };
  },
  computed: {},
  watch: {
    currentIndex(){
      this.clickNum()
    }
  },
  mounted() {
    this.getPage()
  },
  beforeDestroy() {
    this.stopAutoPlay();
    this.closeSSE();
  },
  methods: {
    /** 根据货架号获取大屏数据：货架号、批次号、商品列表  */
    getPage() {
      waveApi.getWavePageFirst({sortingStation:this.SortingStation}).then(res=>{
        // 大屏右上角 波次号 赋值
        this.waveId = res.data.waveId;
        // 大屏左侧sku 赋值
        if (res.data.basket && res.data.basket.length) {
          res.data.basket.forEach(item => {
            item.isRed = false
            item.isGreen = false
          });
          // 左侧列表总数据
          this.leftListData = this.chunkArray(res.data.basket)
          // 左侧轮播数据
          this.leftDataShowList = this.leftListData[0]
          // 左侧轮播列表开始轮播
          this.startAutoPlay()
        } else {
          this.leftListData = [];
          this.leftDataShowList = [];
          this.stopAutoPlay();
        }
        // 左侧列表数据加工
        this.connectSSE(this.SortingStation,res.data.orderPickHistoryVOS)
        // 右侧列表数据
        this.pickHistoryList = res.data.orderPickHistoryVOS || []
      })
    },
    // 数组每二十条拆分
    chunkArray(arr) {
      const chunks = [];
      for (let i = 0; i < arr.length; i += 20) {
        chunks.push(arr.slice(i, i + 20));
      }
      return chunks;
    },
    // 开始轮播
    startAutoPlay() {
      this.stopAutoPlay(); // 先清除所有定时器
      this.timer = setInterval(() => this.nextSlide(), 5000);
    },
    // 暂停轮播
    goToSlide(index) {
      this.currentIndex = index;
      this.isPlay = false;
      this.stopAutoPlay(); // 暂停轮播
    },
    // 继续轮播
    nextSlide() {
      if (!this.leftListData.length) return;
      // % ： 超过leftListData.length就回到第一页
      this.currentIndex = (this.currentIndex + 1) % this.leftListData.length;
      this.clickNum();
    },
    // 清空计时器
    stopAutoPlay() {
      clearInterval(this.timer);
      clearTimeout(this.timeout); // 新增清除setTimeout
      this.timer = null;
      this.timeout = null;
    },
    // 轮播列表赋值
    clickNum(){
      this.leftDataShowList = this.leftListData[this.currentIndex]
    },
    // 系统提示音
    beep(duration = 300, frequency = 880, volume = 1, type = 'sine') {
      const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioCtx.createOscillator();
      const gainNode = audioCtx.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioCtx.destination);

      gainNode.gain.value = volume;
      oscillator.frequency.value = frequency;
      oscillator.type = type; // 可选值: 'sine', 'square', 'sawtooth', 'triangle'

      oscillator.start();
      oscillator.stop(audioCtx.currentTime + duration / 1000);
    },
    // 打印文件
    async printSimpleByUrls(urls, jobId) {
      const PRINT_API = 'https://127.0.0.1:33333/print-simple';
      const res = await fetch(PRINT_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ urls, jobId })
      });

      if (!res.ok) {
        const text = await res.text().catch(() => '');
        throw new Error(`本地打印服务请求失败: ${res.status} ${text}`);
      }

      return await res.json().catch(() => null);
    },
    // 生成本次打印任务唯一编号，仅用于日志追踪和本地打印服务识别
    buildPrintJobId(data, urls) {
      this.printJobSeq += 1;
      return `${this.waveId}-${data.basketNo}-${data.sku}-${urls.length}-${Date.now()}-${this.printJobSeq}`;
    },
    // 将打印任务加入队列，后续由队列按顺序串行执行
    enqueuePrintJob(urls, jobId) {
      this.printQueue.push({ urls, jobId });
      console.log('已加入打印队列:', {
        任务编号: jobId,
        文件数量: urls.length,
        队列长度: this.printQueue.length,
        当前是否正在打印: this.isPrinting
      });
      this.runPrintQueue();
    },
    // 执行打印队列，同一时间只允许一个打印任务提交到本地打印服务
    async runPrintQueue() {
      if (this.isPrinting) {
        return;
      }

      const job = this.printQueue.shift();
      if (!job) {
        return;
      }

      this.isPrinting = true;
      console.log('开始执行打印任务:', {
        任务编号: job.jobId,
        文件数量: job.urls.length,
        剩余队列长度: this.printQueue.length
      });

      try {
        await this.printSimpleByUrls(job.urls, job.jobId);
        console.log('打印任务提交成功');
      } catch (err) {
        console.error('打印任务提交失败');
      } finally {
        this.isPrinting = false;
        console.log('打印任务结束');
        this.runPrintQueue();
      }
    },
    // 列表数据加工方法
    connectSSE(SortingStation,rightList) {
      const env = VUE_APP_WAVE_API();
      const sseUrl = `${env}/pick-order/connect/${SortingStation}`;
      const hasExistingConnection = !!this.sse;
      this.closeSSE();
      this.sse = new EventSource(sseUrl);
      this.sse.onopen = () => {
        console.log('[波次SSE] 连接已建立:', {
          分拣台: SortingStation,
          连接地址: sseUrl,
          建连前是否已有连接: hasExistingConnection,
          连接状态: this.sse && this.sse.readyState
        });
      };

      // 循环寻找满足条件 而后 改变颜色值
      this.sse.onmessage = (e) => { 
        if(e.data == ':hearbeat'){
          return;
        } else{
          const data = JSON.parse(e.data);
          // 根据当前波次状态判定操作
          if(data.instruction == 'PRINT'){
            console.log('[波次SSE] 收到PRINT指令，准备刷新页面数据');
            // 刷新页面
            this.getPage()
          }else{
            // 大屏左侧过滤 红绿色
            data.basket&&data.basket.forEach(item => {
              item.isRed = false
              item.isGreen = false
              if(item.totalItemQty == item.sortQty){
                item.isGreen = true
              }
              data.orderNoList && data.orderNoList.forEach(jitem=>{
                if(item.outerOrderNo == jitem){
                  item.isRed = true
                }
              })
            });
            // 大屏左侧 赋值
            if(data.basket){
              // 左侧列表总数据
              this.leftListData = this.chunkArray(data.basket)
              // 左侧轮播数据
              this.leftDataShowList = this.leftListData[0]
              // 如果命中当前拣货订单，跳到对应轮播页   ==》》》  data.outerOrderNo : 当前拣货订单
              const zIndex = data.basket.findIndex(item => item.outerOrderNo == data.outerOrderNo)
              if(zIndex > -1 && this.isPlay){
                this.currentIndex = Math.floor(zIndex / 20)
                // 等待五秒，继续轮播
                this.startAutoPlay()
              }
            }
            // 判断是否和前一单 篮子号 重复，如果重复 标红+1+2+3
            if( this.centerNumber && data.basketNo == this.centerNumber){
              this.tipsNumber += 1
            }else{
              this.tipsNumber = 0
            }
            // 大屏上中间 波次状态 赋值
            this.waveStatus = data.waveStatus
            // 大屏正中间 篮子号 赋值
            this.centerNumber = JSON.parse(JSON.stringify(data.basketNo))
            // 篮子号赋值/变更 响系统提示音
            if(this.centerNumber){
              this.beep()
            }
            // 大屏正中间 sku编码 赋值
            this.SKUCode = data.sku
            // 大屏正中间 已扫描商品数量 赋值
            this.pickQty = data.pickQty
            // 大屏正中间 总商品数量 赋值
            this.totalItemQty = data.totalItemQty
            // 大屏右侧拣货历史 赋值
            this.pickHistoryList = data.orderPickHistoryVOS?data.orderPickHistoryVOS:rightList
  
            // TODO   labelUrl是后端返回的url list进行打印
            if (data.labelUrl?.length && this.$route.query.print == 1) {
              const sortedUrls = [];
              let basketUrl = null;
              let pickOrderUrl = null;
              const courierUrls = [];
  
              for (const url of data.labelUrl) {
                if (url.includes('/printBasketNo')) {
                  basketUrl = url;
                } else if (url.includes('/printPickOrder')) {
                  pickOrderUrl = url;
                } else {
                  courierUrls.push(url);
                }
              }
              if (basketUrl) sortedUrls.push(basketUrl);
              if (pickOrderUrl) sortedUrls.push(pickOrderUrl);
              if (courierUrls.length) sortedUrls.push(...courierUrls);

              const urls = sortedUrls;
              const jobId = this.buildPrintJobId(data, urls);
              this.enqueuePrintJob(urls, jobId);
            }
          }
        }
      };

      this.sse.onerror = () => {
        console.warn('[波次SSE] 连接断开或异常，20秒后刷新页面');
        setTimeout(() => location.reload(), 20000);
      };
    },
    // 关闭当前SSE连接，避免刷新页面数据时重复建立连接
    closeSSE() {
      if (this.sse) {
        this.sse.close();
        this.sse = null;
        console.log('[波次SSE] 已关闭连接。');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .screen-container {
    width: 100%;
    height: 100vh;
    background-color: #F0F0FD;
  }
  .screen-header {
    width: 100%;
    height: calc(275 / 2160 * 100vh);
    border-radius: 0 0 30px 30px;
    background-color: #FFFFFF;
    font-size: calc(60 / 2160 * 100vh);
    position: relative;
      .left {
        width: calc(810 / 3840 * 100vw);
        height: calc(170 / 2160 * 100vh);
        border-radius: 100px;
        background-color: #FFF7E3;
        display: flex;
        align-items: center;
        justify-content: space-around;
        text-align: center;
        position: absolute;
        left: calc(135 / 3840 * 100vw);
        top: 70%;
        transform: translateY(-80%);
        .yelloText{
          // font-size: calc(12px + 0.6vw);
          width: calc(150 / 3840 * 100vw);
          height: calc(150 / 2160 * 100vh);
          line-height: calc(150 / 2160 * 100vh);
          background-color: #FFB60D;
          color: #FFFFFF;
          border-radius: 50%;
        }
      }
      .center {
        width: calc(810 / 3840 * 100vw);
        height: calc(170 / 2160 * 100vh);
        border-radius: 100px;
        background-color: #D0F7A6;
        display: flex;
        align-items: center;
        justify-content: space-around;
        text-align: center;
        position: absolute;
        left: calc((1970 - 450) / 3840 * 100vw);
        top: 70%;
        transform: translateY(-80%);
      }
      .right {
        width: calc(630 / 3840 * 100vw);
        height: calc(170 / 2160 * 100vh);
        border-radius: 100px;
        background-color: #FFEAF0;
        display: flex;
        align-items: center;
        justify-content: space-around;
        text-align: center;
        font-size: calc(12px + 1vw);
        position:absolute;
        right: calc(135 / 3840 * 100vw);
        top: 70%;
        transform: translateY(-80%);
        .redText{
          font-size: calc(12px + 0.6vw);
          width: calc(150 / 3840 * 100vw);
          height: calc(150 / 2160 * 100vh);
          line-height: calc(150 / 2160 * 100vh);
          background-color: #FF456E;
          color: #FFFFFF;
          border-radius: 50%;
        }
      }
  }
  .screen-body {
    width: 100%;
    height: calc(100vh - (275 / 2160 * 100vh));
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .body-box{
      width: 100%;
      height: 85vh;
      display: flex;
      justify-content: space-around;
      .body-left-select{
        width: calc(915 / 3840 * 100vw);
        height: 5%;
        margin-bottom: 2%;
        border-radius: 30px 30px 30px 30px;
        font-size: 1.8vh;
        background-color: #FFFFFF;
        padding: 10px;
        display: flex;
        justify-content: flex-start;
        .num{
          width: calc(70 / 3840 * 100vw);
          height: calc(70 / 2160 * 100vh);
          line-height: calc(70 / 2160 * 100vh);
          margin-left: calc(90 / 3840 * 100vw);
          text-align: center;
          border: #D9DADF 1px solid;
        }
      }
      .body-left-title{
        width: calc(915 / 3840 * 100vw);
        height: 3%;
        border-radius: 30px 30px 0px 0px;
        font-size: 1.8vh;
        background-color: #FFFFFF;
        padding: 10px;
        display: flex;
        justify-content: space-around;
      }
      .body-left-list{
        width: calc(915 / 3840 * 100vw);
        height: 90%;
        border-radius: 0px 0px 30px 30px;
        font-size: 1.8vh;
        background-color: #FFFFFF;
        padding: 10px;
        .left-box{
          width: 100%;
          height: 100%;
          display: flex;
          align-content: flex-start;
          flex-wrap: wrap;
          // background-color: saddlebrown;
          .product{
            width: 100%;
            height: 5%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            // margin-bottom: 1px;
            // background-color: seagreen;
            position: relative;
          }
          .product::after{
            content: '';
            width: 90%;
            position: absolute;
            left: 5%;
            bottom: 3px;
            border-bottom: 2px dashed #E3E3E3;
          }
          .product_bot{
            width: 100%;
            height: 5%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            // background-color: seagreen;
          }
        }
      }
      .body-center{
        width: calc(1500 / 3840 * 100vw);
        height: 100%;
        text-align: center;
        position: relative;
        .centerNum{
          width: calc(1215 / 3840 * 100vw);
          height: calc(1215 / 2160 * 100vh);
          line-height: calc(1020 / 2160 * 100vh);
          border-radius: 30px;
          box-shadow: 7px 9px 21px 2px rgb(0 0 0 / 63%);
          margin-left: calc(50% - calc(1215 / 3840 * 100vw) / 2);
          // margin-top: 0;
          font-weight: bold;
          font-size: calc(670 / 2160 * 100vh);
          color: #FFFFFF;
          background-color: #395EDD;
          position: absolute;
          left: 0;
          bottom: 23vh;
        }
        .tips{
          width: 6vh;
          height: 6vh;
          line-height: 6vh;
          font-size: 3vh;
          border-radius: 50%;
          color: #fff;
          background-color: #ff456e;
          position: absolute;
          right: 4vh;
          top: 4vh;
        }
        .centerCode{
          width: calc(1500 / 3840 * 100vw);
          height: calc(280 / 2160 * 100vh);
          line-height: calc(130 / 2160 * 100vh);
          font-size: calc(100 / 2160 * 100vh);
          border-radius: 30px;
          box-shadow: 4px 7px 12px 0px #c0c4cc;
          background-color: #FFFFFF;
          position: absolute;
          left: 0;
          bottom: 15vh;
        }
      }
      .body-right{
        width: calc(915 / 3840 * 100vw);
        height: 100%;
        border-radius: 30px;
        font-size: 1.8vh;
        background-color: #FFFFFF;
        padding: 10px;
        .body-right-title{
          width: calc(915 / 3840 * 100vw);
          height: 3%;
          border-radius: 30px 30px 0px 0px;
          font-size: 1.8vh;
          padding: 10px;
          display: flex;
          justify-content: space-around;
        }
        .right-box{
          width: 100%;
          height: 97%;
          display: flex;
          align-content: flex-start;
          flex-wrap: wrap;
          // background-color: saddlebrown;
          .product{
            width: 100%;
            height: 5%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            // margin-bottom: 1px;
            // background-color: seagreen;
            position: relative;
          }
          .product::after{
            content: '';
            width: 90%;
            position: absolute;
            left: 5%;
            bottom: 3px;
            border-bottom: 2px dashed #E3E3E3;
          }
          .product_bot{
            width: 100%;
            height: 5%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            // background-color: seagreen;
          }
        }
      }
    }
  }
  .redTips{
    color: #FFFFFF;
    background-color: #FF456E;
    border-radius: 20px;
  }
  .greenTips{
    color: #FFFFFF;
    background-color: #68c55c;
    border-radius: 20px;
  }
  .numTips{
    color: #FFFFFF;
    background-color: #1488F5;
  }
</style>
